module.exports = __webpack_public_path__ + "static/img/invest-envir2.7d08077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-envir2.jpg
// module id = dX/5
// module chunks = 0